var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65625 4.75H7.84375C8.14062 4.73438 8.34375 4.60156 8.45312 4.35156C8.54688 4.10156 8.5 3.86719 8.3125 3.64844L5.21875 0.4375C5.07812 0.3125 4.92188 0.25 4.75 0.25C4.57812 0.25 4.42969 0.3125 4.30469 0.4375L1.1875 3.64844C1 3.86719 0.953125 4.10156 1.04688 4.35156C1.15625 4.60156 1.35938 4.73438 1.65625 4.75Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSortAsc);
export default __webpack_public_path__ + "static/media/icons_sort_asc.d9e8d0a3.svg";
export { ForwardRef as ReactComponent };